import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { MessageFormComponent } from './components/message-form/message-form.component';
import { MessageListComponent } from './components/message-list/message-list.component';
import { LinkifyPipe } from './linkify.pipe';
import { PushNotificationsModule } from 'ng-push-ivy';
import { AsistenciaChatComponent } from './asistencia-chat.component';
import { MessageItemComponent } from './components/message-item/message-item.component';

import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { InformModalComponent } from '../inform-modal/inform-modal.component';
import { MaterialModule } from './material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AsistenteVentanaModule } from '../asistente-ventana/asistente-ventana.module';
import { BasecomponentsModule } from '../../basecomponents/basecomponents.module';

@NgModule({
   declarations: [
      MessageItemComponent,
      MessageFormComponent,
      MessageListComponent,
      AsistenciaChatComponent,
      ConfirmModalComponent,
      InformModalComponent,
      LinkifyPipe
   ],
   imports: [
      FormsModule,
      HttpClientModule,
      PushNotificationsModule,
      MaterialModule,
      BrowserAnimationsModule,
      BasecomponentsModule
   ],
   exports: [
      AsistenciaChatComponent
   ],
   providers: [
   ],
   bootstrap: [
      AsistenciaChatComponent
   ],
   entryComponents: [
      ConfirmModalComponent,
      InformModalComponent
   ],
   schemas: [
      CUSTOM_ELEMENTS_SCHEMA
   ]
})
export class AsistenciaChatModule { }

